import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../config/api';

// spec v41 - Proyectos por Cerrar.
// Bandeja de proyectos Activos con oferta Aprobada 100% proyectados y cobrados
// (todos los anios). JC revisa y aprueba el cierre -> el proyecto pasa a
// 'Terminado' via GET-then-PUT de /proyectos (el PUT reemplaza el registro
// completo, por eso se re-envia el registro entero con estado cambiado).

const fmt = (n) => (n == null || isNaN(n)) ? '—' : Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const simbolo = (m) => m === 'Dólares' ? '$' : m === 'Euros' ? '€' : '₡';

export default function ProyectosPorCerrar() {
  const [candidatos, setCandidatos] = useState([]);
  const [sel, setSel] = useState({});
  const [expand, setExpand] = useState({});
  const [cargando, setCargando] = useState(true);
  const [procesando, setProcesando] = useState(false);
  const [confirmar, setConfirmar] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => { cargar(); }, []);

  const cargar = async () => {
    setCargando(true); setMsg('');
    try {
      const r = await axios.get(`${API}/proyeccion-facturacion?action=candidatos-cierre`);
      const c = r.data?.candidatos || [];
      setCandidatos(c);
      const n = {};
      c.forEach(p => { n[p.proyecto_id_pk] = true; }); // todos marcados por default (incluye sub-cobrados)
      setSel(n);
      setExpand({});
    } catch (e) {
      setMsg('Error al cargar: ' + (e.response?.data?.error || e.message));
    }
    setCargando(false);
  };

  const seleccionados = candidatos.filter(p => sel[p.proyecto_id_pk]);
  const todosSel = candidatos.length > 0 && candidatos.every(p => sel[p.proyecto_id_pk]);

  const toggleTodos = () => {
    if (todosSel) setSel({});
    else { const n = {}; candidatos.forEach(p => n[p.proyecto_id_pk] = true); setSel(n); }
  };

  const cerrar = async () => {
    setConfirmar(false);
    if (!seleccionados.length) return;
    setProcesando(true); setMsg('');
    const okCodes = [], failCodes = [];
    for (const p of seleccionados) {
      try {
        // GET registro completo -> re-PUT con estado='Terminado'.
        // El PUT de /proyectos sobrescribe TODAS las columnas, por eso se
        // re-envia el objeto entero (round-trip probado en Proyectos.js).
        const g = await axios.get(`${API}/proyectos?id=${p.proyecto_id_pk}`);
        const proy = { ...g.data, estado: 'Terminado' };
        const put = await axios.put(`${API}/proyectos?id=${p.proyecto_id_pk}`, proy);
        if (put.data && put.data.ok === false) failCodes.push(p.proyecto_id);
        else okCodes.push(p.proyecto_id);
      } catch (e) {
        failCodes.push(p.proyecto_id);
      }
    }
    let m = `${okCodes.length} proyecto(s) cerrado(s) a Terminado.`;
    if (failCodes.length) m += ` No se pudieron cerrar: ${failCodes.join(', ')}.`;
    setMsg(m);
    await cargar();
    setProcesando(false);
  };

  return (
    <div style={{ padding: '24px', fontFamily: 'Segoe UI, sans-serif', maxWidth: '1100px' }}>
      <div style={{ background: '#012E40', borderRadius: '12px', padding: '16px 20px', marginBottom: '8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <div style={{ color: '#fff', fontSize: '17px', fontWeight: '700' }}>Proyectos por Cerrar</div>
          <div style={{ color: '#9fc0cc', fontSize: '12px', marginTop: '2px' }}>Todo proyectado y 100% cobrado, todos los años. Vos aprobás el cierre a Terminado.</div>
        </div>
        <button onClick={() => setConfirmar(true)} disabled={procesando || !seleccionados.length}
          style={{ padding: '8px 18px', background: seleccionados.length ? '#87B749' : '#9bb', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: seleccionados.length ? 'pointer' : 'not-allowed', opacity: procesando ? 0.7 : 1, whiteSpace: 'nowrap' }}>
          {procesando ? 'Cerrando...' : `Cerrar seleccionados (${seleccionados.length})`}
        </button>
      </div>

      <div style={{ fontSize: '12px', color: '#888', margin: '10px 2px 16px' }}>
        {candidatos.length} candidato(s) listo(s) para cerrar.
      </div>

      {msg && <div style={{ background: '#EAF3DE', border: '1px solid #b8dfc8', borderRadius: '8px', padding: '10px 14px', fontSize: '13px', color: '#3B6D11', marginBottom: '14px' }}>{msg}</div>}

      <div style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: '12px', overflow: 'hidden' }}>
        {cargando ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#888' }}>Cargando...</div>
        ) : candidatos.length === 0 ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#bbb' }}>No hay proyectos listos para cerrar.</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
            <thead>
              <tr style={{ background: '#f8f9fa' }}>
                <th style={{ padding: '11px 14px', width: '36px' }}><input type="checkbox" checked={todosSel} onChange={toggleTodos} /></th>
                <th style={{ padding: '11px 14px', width: '28px' }}></th>
                {[['Proyecto', 'left'], ['Contratado', 'right'], ['Cobrado', 'right'], ['Estado', 'left']].map(([h, al]) => (
                  <th key={h} style={{ padding: '11px 14px', textAlign: al, color: '#888', fontWeight: '600', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '1px solid #eee' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {candidatos.map(p => {
                const abierto = !!expand[p.proyecto_id_pk];
                return (
                  <React.Fragment key={p.proyecto_id_pk}>
                    <tr style={{ borderBottom: abierto ? 'none' : '1px solid #f3f3f3' }}>
                      <td style={{ padding: '10px 14px', textAlign: 'center' }}>
                        <input type="checkbox" checked={!!sel[p.proyecto_id_pk]} onChange={e => setSel(s => ({ ...s, [p.proyecto_id_pk]: e.target.checked }))} />
                      </td>
                      <td style={{ padding: '10px 6px', textAlign: 'center' }}>
                        <button onClick={() => setExpand(s => ({ ...s, [p.proyecto_id_pk]: !abierto }))}
                          style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: '#888', fontSize: '11px', padding: '2px 4px' }}>
                          {abierto ? '▾' : '▸'}
                        </button>
                      </td>
                      <td style={{ padding: '10px 14px' }}>
                        <div style={{ color: '#012E40', fontWeight: '600' }}>{p.proyecto_id} · {p.proyecto_nombre}</div>
                        <div style={{ color: '#999', fontSize: '11.5px', marginTop: '2px' }}>
                          {(p.cliente_nombre || 'Sin cliente')} · Oferta {p.oferta_numero_ofs} · {p.lineas.length} línea(s)
                        </div>
                      </td>
                      <td style={{ padding: '10px 14px', textAlign: 'right', color: '#555' }}>{simbolo(p.moneda)}{fmt(p.total_contratado)}</td>
                      <td style={{ padding: '10px 14px', textAlign: 'right', fontWeight: '600', color: '#012E40' }}>{simbolo(p.moneda)}{fmt(p.total_cobrado)}</td>
                      <td style={{ padding: '10px 14px' }}>
                        <span style={{ background: '#EAF3DE', color: '#3B6D11', padding: '2px 8px', borderRadius: '8px', fontSize: '11px', fontWeight: '600' }}>100% cobrado</span>
                        {p.sub_cobrado && (
                          <span style={{ background: '#FDF2E0', color: '#9A6414', padding: '2px 8px', borderRadius: '8px', fontSize: '11px', fontWeight: '600', marginLeft: '6px' }}>sub-cobrado</span>
                        )}
                        {p.es_recurrente && (
                          <span style={{ background: '#E6EFF6', color: '#185FA5', padding: '2px 8px', borderRadius: '8px', fontSize: '11px', fontWeight: '600', marginLeft: '6px' }}>Recurrente · OC agotada</span>
                        )}
                      </td>
                    </tr>
                    {abierto && (
                      <tr style={{ borderBottom: '1px solid #f3f3f3', background: '#fbfcfd' }}>
                        <td colSpan={6} style={{ padding: '4px 14px 14px 58px' }}>
                          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                            <thead>
                              <tr>
                                {[['Línea', 'left'], ['Contratado', 'right'], ['Cobrado', 'right'], ['', 'left']].map(([h, al], i) => (
                                  <th key={i} style={{ padding: '6px 10px', textAlign: al, color: '#aaa', fontWeight: '600', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{h}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {p.lineas.map((l, i) => (
                                <tr key={i} style={{ background: l.sub_cobrado ? '#FDF2E0' : 'transparent' }}>
                                  <td style={{ padding: '6px 10px', color: '#333' }}>{l.numero_linea}. {l.descripcion_corta || '(sin descripción)'}</td>
                                  <td style={{ padding: '6px 10px', textAlign: 'right', color: '#666' }}>{simbolo(p.moneda)}{fmt(l.contratado)}</td>
                                  <td style={{ padding: '6px 10px', textAlign: 'right', color: '#012E40', fontWeight: '600' }}>{simbolo(p.moneda)}{fmt(l.cobrado)}</td>
                                  <td style={{ padding: '6px 10px', color: '#9A6414', fontSize: '11px' }}>
                                    {l.sub_cobrado ? `cobró ${simbolo(p.moneda)}${fmt(l.contratado - l.cobrado)} menos que lo contratado` : ''}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          {p.sub_cobrado && (
                            <div style={{ fontSize: '11px', color: '#9A6414', marginTop: '8px' }}>
                              Todo está cobrado, pero alguna línea cobró menos que lo contratado (proyección parcial legacy). Revisá antes de cerrar.
                            </div>
                          )}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {confirmar && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', maxWidth: '420px', boxShadow: '0 8px 30px rgba(0,0,0,0.2)' }}>
            <div style={{ fontSize: '16px', fontWeight: '700', color: '#012E40', marginBottom: '10px' }}>Confirmar cierre</div>
            <div style={{ fontSize: '13px', color: '#555', lineHeight: '1.5', marginBottom: '20px' }}>
              Vas a cerrar <b>{seleccionados.length}</b> proyecto(s). Pasarán a estado <b>Terminado</b> y saldrán de la matriz de Proyección. ¿Continuar?
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button onClick={() => setConfirmar(false)} style={{ padding: '8px 16px', background: '#fff', color: '#555', border: '1px solid #ddd', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>Cancelar</button>
              <button onClick={cerrar} style={{ padding: '8px 16px', background: '#87B749', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>Cerrar proyectos</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}